module.exports = __webpack_public_path__ + "assets/05e0f5ef52513f32d66c35d16e4cf9b8.png";